import React, { createContext, useContext, useState, useEffect } from 'react';
import {
  getAuth,
  onAuthStateChanged,
  signInWithCustomToken,
  inMemoryPersistence,
  setPersistence
} from 'firebase/auth';
import PropTypes from 'prop-types';
import axios from 'axios';
import { SettingsContext } from './Settings';
import { getAuthBaseUrl } from '../helpers/Util';
import Loader from '../components/Loader';

export const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default function AuthProvider({ children }) {
  const auth = getAuth();
  const { authSettings } = useContext(SettingsContext);

  const [authUser, setAuthUser] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const logout = async () => {
    const data = { uid: auth.currentUser.uid };

    try {
      await axios.post(`${process.env.REACT_APP_API_AUTH_BASE_URL}/logout`, data, {
        headers: { 'Account-Key': authSettings.server.path }
      });
      window.location.href = `${getAuthBaseUrl()}/`;
      return;
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setAuthUser(user);
        setIsLoading(false);
      } else {
        try {
          // TODO - Passar chamada para services
          const response = await axios.get(`${process.env.REACT_APP_API_AUTH_BASE_URL}/status`, {
            withCredentials: true,
            headers: { 'Account-Key': authSettings.server.path }
          });
          const customToken = response.data;
          await setPersistence(auth, inMemoryPersistence);
          await signInWithCustomToken(auth, customToken);
          setIsLoading(false);
        } catch (err) {
          console.error(err);
          window.location.href = `${getAuthBaseUrl()}/`;
        }
      }
    });

    return unsubscribe;
  }, [auth, authSettings]);

  if (isLoading) {
    return <Loader align="center" />;
  }

  return (
    <AuthContext.Provider value={{ authUser, logout }}>
      {!isLoading && children}
    </AuthContext.Provider>
  );
}
